import {
  RegularBenefitVariant,
  ShippingApplyTo,
} from '../../../../../../../typings'

export const EMPTY_FREE_SHIPPING = {
  type: RegularBenefitVariant.FreeShipping as const,
  applyTo: ShippingApplyTo.all,
}
